var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcSocialMediaTwitter16Dp = function SvgIcSocialMediaTwitter16Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.034 1L6.44 8.24 1 14.124h1.224l4.762-5.153 3.848 5.153H15L9.29 6.479 14.354 1H13.13L8.744 5.746 5.2 1H1.034zm1.8.903h1.914L13.2 13.222h-1.913L2.834 1.903z"
  })));
};

export default "/_next/static/ic_social-media-twitter_16dp-88c1b36e3e70fd7ed4cc02533f6cca32svg";
export { SvgIcSocialMediaTwitter16Dp as ReactComponent };